module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-cablecar--black-0dbe2923f37309dfa2152d4c87eecc80.svg";